/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/

import moment from 'moment-timezone';



const validateCardExpiration = (value) => {
  const formatIsValid = /^[0-9]{2}\/[0-9]{2}$/.test(value);
  const date = moment(value, 'MM/YY');
  const dateIsvalid = date.isValid();

  if (formatIsValid && dateIsvalid) {
    date.add(1, 'months');

    if (dateIsvalid && date.diff() > 0) {
      return true;
    }

    return 'Invalid card expiration.';
  }

  return 'Invalid card expiration.';
};



export default validateCardExpiration;
